import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Header from "./components/common/Header.jsx";
import CarPage from "./pages/CarPage.jsx";
import PluginPage from "./pages/PluginPage.jsx";
import HistoryPage from "./pages/HistoryPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";

function AppShell({ children }) {
  return (
    <div className="shell">
      <Header />
      <main style={{ flex: 1 }}>{children}</main>
      <footer className="footer-meta">
        AHistory · web edition
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Public — works without auth (uses shared api_token on the backend). */}
      <Route
        path="/car"
        element={
          <AppShell>
            <CarPage />
          </AppShell>
        }
      />
      {/* Public — page renders, individual sections show "auth required" if not logged in. */}
      <Route
        path="/plugin"
        element={
          <AppShell>
            <PluginPage />
          </AppShell>
        }
      />
      {/* Public — auction history search via stat.vin (no user auth needed). */}
      <Route
        path="/history"
        element={
          <AppShell>
            <HistoryPage />
          </AppShell>
        }
      />
      <Route path="/" element={<Navigate to="/car" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
